class ModalImportUtils {
  get currentUrl() {
    return window.location.pathname
  }
}


export const modalImportUtils = new ModalImportUtils()